import { render, staticRenderFns } from "./Tablet.vue?vue&type=template&id=43e9dfe1&scoped=true&"
import script from "./Tablet.vue?vue&type=script&lang=js&"
export * from "./Tablet.vue?vue&type=script&lang=js&"
import style0 from "./Tablet.vue?vue&type=style&index=0&id=43e9dfe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e9dfe1",
  null
  
)

component.options.__file = "Tablet.vue"
export default component.exports